"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalSubhead = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
const _excluded = ["className", "children", "id"];
const CSS_BLOCK = 'sapcnqr-modal';
const ModalSubhead = exports.ModalSubhead = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      className,
      children,
      id
    } = props,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  const classnames = _bind.default.bind(_Modal.default);
  const subHeadClasses = classnames(`${CSS_BLOCK}__subhead`, className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: subHeadClasses,
    id: id,
    ref: ref
  }), children);
});
ModalSubhead.displayName = 'Modal.Subhead';
ModalSubhead.propTypes = {
  /** Content of the modal subhead. */
  children: _propTypes.default.node,
  /** Custom classes to add to the subhead's `<div>` tag. */
  className: _propTypes.default.string,
  /** @ignore */
  id: _propTypes.default.string
};
var _default = exports.default = ModalSubhead;